import {
  Avatar,
  Badge,
  Divider,
  Grid,
  InlineStack,
  Icon,
  Text,
  BlockStack,
  Card,
  List,
  Image,
  TextField,
  Checkbox,
  Select,
  Box,
  Link,
  Button,
  ButtonGroup,
  InlineGrid,
} from '@shopify/polaris'

import {
  ContractIcon,
  PersonIcon,
  CursorFilledIcon,
  ClipboardCheckIcon,
  ProductIcon,
  CheckIcon,
  FormsIcon,
  PageIcon,
  ImageIcon,
  ClockIcon,
  DeliveryIcon,
  LogoInstagramIcon,
  LogoYoutubeIcon,
  LogoTiktokIcon,
  CashDollarIcon,
} from '@shopify/polaris-icons'
import { numberToUSD } from '../../utils'
// import { AddressElement, useElements } from '@stripe/react-stripe-js';
import { DetailText, SpacedText } from '../atoms';
import { useEffect, useState } from 'react';
import InstructionsRichTextEditor from '../InstructionsRichTextEditor';
import { usePartnerUp } from '../../providers/PartnerUpStoreProvider';

const MAPS_KEY = 'AIzaSyACFv1SiRtvQ6IsAwoRJZeiT8c_UZp9pFQ'

function ContentItem({ format, quantity, showQuantity }) {
  const icon = (
    <InlineStack>
      <Icon color="subdued" source={format.includes('tiktok') ? LogoTiktokIcon : format.includes('youtube') ? LogoYoutubeIcon : format.includes('instagram') ? LogoInstagramIcon : CursorFilledIcon} />
    </InlineStack>
  )
  let contentString = format;
  if (format === 'tiktokShort') {
    contentString = 'TikTok Short'
  } else if (format === 'instagramPost') {
    contentString = 'Instagram Post'
  } else if (format === 'instagramStory') {
    contentString = 'Instagram Story'
  } else if (format === 'youtubeVideo') {
    contentString = 'YouTube Video'
  } else if (format === 'instagramReel') {
    contentString = 'Instagram Reel'
  }
  if (format === 'instagramStory') {
    contentString = `${showQuantity ? quantity : ''} ${showQuantity && quantity === 1 ? 'Instagram Story' : 'Instagram Stories'}`
  } else {
    contentString = `${showQuantity ? quantity : ''} ${contentString}${showQuantity && quantity === 1 ? '' : 's'}`
  }
  return (
    <Card>
      <InlineStack gap="100" align="start">
        {icon}
        <InlineStack align="center">
          <Text variant="headingMd">{contentString}</Text>
        </InlineStack>
      </InlineStack>
    </Card>
  )
}

export default function CampaignDetailsReadOnly({ deal, addressForm = true, canEdit = false }) {
  const { store, setToast } = usePartnerUp()

  const [localNewValues, setLocalNewValues] = useState({})
  const [editingField, setEditingField] = useState()
  const [saveLoading, setSaveLoading] = useState(false)

  const [script, setScript] = useState(deal?.specs?.script || '');
  const [inspiration, setInspiration] = useState(deal?.specs?.inspiration || '');
  const [creativeDirection, setCreativeDirection] = useState(deal?.specs?.creativeDirection || '');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLocalNewValues({
        script,
        inspiration,
        creativeDirection
      })
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [script, inspiration, creativeDirection])

  const groupedVariants = deal?.products?.selectedVariants?.length ? deal?.products?.selectedVariants?.reduce((acc, variant) => {
    if (!acc[variant?.productID]) {
      acc[variant.productID] = {
        product: variant,
        variants: []
      }
    }
    acc[variant.productID].variants.push(variant);
    return acc
  }, {}) : {}

  function handleEditField(field, value = null) {
    setEditingField(field)
    if (field === 'instructions') {
      setLocalNewValues(value)
    } else {
      setLocalNewValues(!value ? {} : { [field]: value })
    }
  }

  async function saveDeal() {
    try {
      setSaveLoading(true)
      let body = localNewValues;

      if (editingField === 'instructions') {
        body = {
          specs: localNewValues
        }
      } else if (editingField === 'contentRights') {
        body = {
          contentRights: {
            terms: localNewValues?.contentRights
          }
        }
      } else if (editingField === 'overview') {
        body = {
          specs: {
            overview: localNewValues?.overview
          }
        }
      } else if (editingField === 'price') {
        body = {
          payments: {
            price: Number(localNewValues?.price)
          }
        }
      }

      console.log('saving body', body)

      /*
      const response = await authFetch(`/api/deals/${deal.id}`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })
*/
      if (response.ok) {
        setToast({ content: 'Offer updated' })
        handleEditField(null)
      } else {
        throw new Error('Error updating offer')
      }
    } catch (e) {
      console.error(e)
      setToast({ content: 'Error updating offer', error: true })
    } finally {
      setSaveLoading(false)
    }
  }

  return (
    <Box paddingBlockEnd="20">
      <BlockStack gap="300">
        <BlockStack>
          <div style={{ padding: '40px 0', backgroundColor: 'white' }}>
            <BlockStack gap="6" inlineAlign="center">
              <BlockStack gap="200">
                <div style={{ textAlign: 'center' }}>
                  <SpacedText>Apply For</SpacedText>
                </div>
                <img src={store?.logo} style={{ width: '200px', height: 'auto' }} />
              </BlockStack>
              <DetailText>{deal?.publicTitle}</DetailText>
            </BlockStack>
          </div>
          <div style={{
            width: '100%',
            height: '300px',
            backgroundColor: 'lightgray',
            backgroundImage: `url("${deal?.hero ? deal.hero : 'https://assets.codepen.io/6060109/default-lp-hero-1.jpg'}")`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: deal?.heroSize === 'Full Width' ? '100%' : deal?.heroSize === 'Full Height' ? 'auto 100%' : deal?.heroSize === 'contain' ? 'contain' : 'cover',
            backgroundPosition: deal?.heroPosition === 'top' ? 'top' : deal?.heroPosition === 'center' ? 'center' : 'bottom',
          }}>
          </div>
        </BlockStack>
        <Card>
          <BlockStack gap="500">
            <InlineStack align="space-between">
              <InlineStack gap="300" align="start">
                <InlineStack>
                  <Icon source={PersonIcon} />
                </InlineStack>
                <BlockStack gap="100">
                  <Text variant="headingMd">Campaign Overview</Text>
                </BlockStack>
              </InlineStack>
              {
                canEdit ? (editingField === 'overview' ? <ButtonGroup>
                  <Button size="slim" onClick={saveDeal} loading={saveLoading}>Save</Button>
                  <Button size="slim" onClick={() => handleEditField(null)}>Cancel</Button>
                </ButtonGroup> : (
                  <Button size="slim" onClick={() => handleEditField('overview', deal?.specs?.overview)}>Edit</Button>
                )) : null
              }
            </InlineStack>
            <Divider />
            <BlockStack gap="300">
              {
                editingField === 'overview' ? (
                  <InstructionsRichTextEditor value={localNewValues?.overview} setValue={v => {
                    setLocalNewValues({ ...localNewValues, overview: v })
                  }
                  } />
                ) : <div dangerouslySetInnerHTML={{ __html: deal?.specs?.overview }} />
              }
            </BlockStack>
          </BlockStack>

        </Card>
        {
          (deal?.payments?.includeAffiliate) && (
            <Card>
              <BlockStack gap="500">
                <InlineStack align="space-between">
                  <InlineStack gap="300" align="start" blockAlign="center">
                    <InlineStack>
                      <Icon source={CursorFilledIcon} />
                    </InlineStack>
                    <BlockStack gap="100">
                      <Text variant="headingMd">Affiliate</Text>
                    </BlockStack>
                  </InlineStack>
                </InlineStack>
                <Divider />
                <InlineGrid gap="500" columns="2">
                  {
                    deal?.affiliateFields?.discountType === 'percentage' ? (
                      <BlockStack>
                        <Text variant="headingLg">{deal?.affiliateFields?.discountPercentage}% Discount</Text>
                        <Text>For Customers</Text>
                      </BlockStack>
                    ) : deal?.affiliateFields?.discountType === 'fixed' ? (
                      <BlockStack>
                        <Text variant="headingLg">{numberToUSD(deal?.affiliateFields?.discountFixedValue, store?.paymentSettings?.currencyCode, 0)} Discount</Text>
                        <Text>For Customers, Per Order</Text>
                      </BlockStack>
                    ) : (
                      <BlockStack>
                        <Text variant="headingLg">Free Shipping</Text>
                        <Text>For Customers {deal?.affiliateFields?.usOnly ? ' US Only' : ''}</Text>
                      </BlockStack>
                    )
                  }
                  <BlockStack>
                    <Text variant="headingLg">{deal?.affiliateFields?.commission}% Commission</Text>
                    <Text>On Revenue</Text>
                  </BlockStack>
                </InlineGrid>
              </BlockStack>
            </Card>
          )
        }
        {
          (deal?.payments?.price) ? (
            <Card>
              <BlockStack gap="500">
                <InlineStack align="space-between">
                  <InlineStack gap="300" align="start" blockAlign="center">
                    <InlineStack>
                      <Icon source={CashDollarIcon} />
                    </InlineStack>
                    <BlockStack gap="100">
                      <Text variant="headingMd">Fixed Payment</Text>
                    </BlockStack>
                  </InlineStack>
                  {
                    canEdit ? (
                      editingField === 'price' ? (
                        <ButtonGroup>
                          <Button size="slim" onClick={saveDeal} loading={saveLoading}>Save</Button>
                          <Button size="slim" onClick={() => handleEditField(null)}>Cancel</Button>
                        </ButtonGroup>
                      ) : (
                        <Button onClick={() => {
                          handleEditField('price', deal.payments?.price)
                        }} size="slim">Edit</Button>
                      )
                    ) : null
                  }
                </InlineStack>
                <Divider />
                <InlineGrid gap="500" columns="2">
                  {
                    editingField === 'price' ? (
                      <TextField
                        prefix={<Text>$</Text>}
                        value={localNewValues?.price}
                        onChange={v => {
                          setLocalNewValues({ ...localNewValues, price: v })
                        }}
                        helpText={<Text>On Full Delivery</Text>}
                      />
                    ) : (
                      <BlockStack>
                        <Text variant="headingLg">{numberToUSD(deal.payments?.price, store?.paymentSettings?.currencyCode)}</Text>
                        <Text>On Full Delivery</Text>
                      </BlockStack>
                    )
                  }
                </InlineGrid>
              </BlockStack>
            </Card>
          ) : canEdit ? (
            null
            /*
            <Box padding="5">
              <InlineStack align="center">
                <Button size="slim">Add Fixed Payment</Button>
              </InlineStack>
            </Box>
              */
          ) : null
        }
        {
          (deal?.content?.formats?.length) && (
            <Card>
              <BlockStack gap="500">
                <InlineStack align="space-between">
                  <InlineStack gap="300" align="start" blockAlign="center">
                    <InlineStack>
                      <Icon source={ImageIcon} />
                    </InlineStack>
                    <BlockStack>
                      <Text variant="headingMd">Content</Text>
                    </BlockStack>
                  </InlineStack>
                  <BlockStack inlineAlign="center">
                    {
                      deal?.content?.baseType === 'evergreen' ? (
                        <InlineStack gap="100" inlineAlign="end">
                          <Text>Post as much as you want!</Text>
                          <Badge status="success">Evergreen</Badge>
                        </InlineStack>
                      ) : (
                        <InlineStack gap="100" blockAlign="center" inlineAlign="start">
                          <Text variant="headingSm">{deal?.content?.baseType === 'fixed' ? "Deadline in" : "Every"} </Text>
                          <Text variant="headingSm">{deal.content?.dueInDays} Days</Text>
                          <Badge status="info">{deal?.content?.baseType === 'fixed' ? "Fixed" : "Recurring"}</Badge>
                        </InlineStack>
                      )
                    }
                    {
                      deal?.content?.dueDate && (
                        new Date(deal?.content?.dueDate) < new Date() ? (
                          <Badge status="critical">overdue {new Date(deal?.content?.dueDate).toLocaleDateString()}</Badge>
                        ) : (
                          <Badge>Due {new Date(deal?.content?.dueDate)?.toLocaleDateString()}</Badge>
                        )
                      )
                    }
                  </BlockStack>
                </InlineStack>
                <Divider />
                <InlineStack>
                  <InlineGrid gap="100" columns="2">
                    {
                      deal?.content?.formats?.map((formatItem, index) => {
                        const format = Object.keys(formatItem)[0]
                        const quantity = formatItem[format]
                        return (
                          <ContentItem key={index} format={format} quantity={quantity} showQuantity={deal?.content?.baseType !== 'evergreen'} />
                        )
                      })
                    }
                  </InlineGrid>
                </InlineStack>
                <Divider />
                <InlineStack align="space-between">
                  <InlineStack gap="200">
                    {
                      deal?.content?.delayOnAccept ? (
                        <InlineStack blockAlign="center">
                          <Icon source={ClockIcon} color="base" />
                          {
                            deal?.content?.delayStartDays === 0 ? (
                              <Text variant="bodySm">Starts on Accept</Text>
                            ) : (
                              <Text variant="bodySm">Starts {deal?.content?.delayStartDays} Days After Accepted</Text>
                            )
                          }
                        </InlineStack>
                      ) : null
                    }
                  </InlineStack>
                  <InlineStack gap="200">
                    {
                      deal?.content?.reviewContent ? (
                        <InlineStack blockAlign="center">
                          <Icon source={CheckIcon} color="success" />
                          <Text variant="bodySm" color="success">Content Reviewed Before Approval</Text>
                        </InlineStack>
                      ) : null
                    }
                  </InlineStack>
                </InlineStack>
              </BlockStack>
            </Card>
          )
        }
        {
          !canEdit && !deal?.specs?.script && !deal?.specs?.creativeDirection && !deal?.specs?.inspiration ? null : (
            <Card>
              <BlockStack gap="500">
                <InlineStack align="space-between">
                  <InlineStack gap="300" align="start">
                    <InlineStack>
                      <Icon source={ClipboardCheckIcon} />
                    </InlineStack>
                    <BlockStack>
                      <Text variant="headingMd">Instructions</Text>
                    </BlockStack>
                  </InlineStack>
                  {
                    canEdit ? (editingField === 'instructions' ? (
                      <ButtonGroup>
                        <Button size="slim" onClick={saveDeal} loading={saveLoading}>Save</Button>
                        <Button size="slim" onClick={() => handleEditField(null)}>Cancel</Button>
                      </ButtonGroup>
                    ) : (
                      <Button size="slim" onClick={() => {
                        handleEditField('instructions', { script: deal?.specs?.script, creativeDirection: deal?.specs?.creativeDirection, inspiration: deal?.specs?.inspiration })
                      }}>Edit</Button>
                    )) : null
                  }
                </InlineStack>
                <Divider />
                <BlockStack gap="500">
                  {
                    editingField === 'instructions' ? (
                      <>
                        <BlockStack gap="200">
                          <Text variant="headingSm">Guidelines</Text>
                          <InstructionsRichTextEditor value={script} setValue={v => {
                            setScript(v)
                          }} />
                        </BlockStack>
                        <Divider />
                        <BlockStack gap="200">
                          <Text variant="headingSm">Creative Direction</Text>
                          <InstructionsRichTextEditor value={creativeDirection} setValue={v => {
                            setCreativeDirection(v)
                          }} />
                        </BlockStack>
                        <Divider />
                        <BlockStack gap="200">
                          <Text variant="headingSm">Inspiration Examples</Text>
                          <InstructionsRichTextEditor value={inspiration} setValue={v => {
                            setInspiration(v)
                          }} />
                        </BlockStack>
                      </>
                    ) : (
                      <>
                        {
                          deal?.specs?.script ? (
                            <BlockStack gap="200">
                              <Text variant="headingSm">Guidelines</Text>
                              <BlockStack gap="100">
                                <div dangerouslySetInnerHTML={{ __html: deal?.specs?.script }} />
                              </BlockStack>
                            </BlockStack>
                          ) : null
                        }
                        {
                          deal?.specs?.creativeDirection ? (
                            <>
                              <Divider />
                              <BlockStack gap="200">
                                <Text variant="headingSm">Creative Direction</Text>
                                <BlockStack gap="100">
                                  <div dangerouslySetInnerHTML={{ __html: deal?.specs?.creativeDirection }} />
                                </BlockStack>
                              </BlockStack>
                            </>
                          ) : null
                        }
                        {
                          deal?.specs?.inspiration ? (
                            <>
                              <Divider />
                              <BlockStack gap="200">
                                <Text variant="headingSm">Inspiration Examples</Text>
                                <BlockStack gap="100">
                                  <div dangerouslySetInnerHTML={{ __html: deal?.specs?.inspiration }} />
                                </BlockStack>
                              </BlockStack>
                            </>
                          ) : null
                        }
                      </>
                    )
                  }
                  {
                    deal?.assets?.length ? (
                      <BlockStack gap="300">
                        <Divider />
                        <Text variant="headingSm">Assets</Text>
                        <InlineStack gap="500" align="start">
                          {
                            deal?.assets?.map((asset, index) => {
                              return (
                                <InlineStack key={index} gap="100" blockAlign="center" align="start">
                                  <InlineStack>
                                    <Icon color="interactive" source={asset?.name?.includes('doc') || asset?.name?.includes('pdf') ? PageIcon : ImageIcon} />
                                  </InlineStack>
                                  <Link removeUnderline url={asset.url}>{asset.name}</Link>
                                </InlineStack>
                              )
                            })
                          }
                        </InlineStack>
                      </BlockStack>
                    ) : null
                  }
                </BlockStack>
              </BlockStack>
            </Card>
          )
        }
        {
          deal?.form?.customFields?.length ? (
            <Card>
              <BlockStack gap="500">
                <InlineStack gap="300" align="start">
                  <InlineStack>
                    <Icon source={FormsIcon} />
                  </InlineStack>
                  <Text variant="headingMd">Questions</Text>
                </InlineStack>
                <Divider />
                {
                  deal?.form?.customFields?.map((field, index) => {
                    return (
                      <BlockStack key={index} gap="300">
                        {
                          field.type === 'text' ? (
                            <BlockStack gap="200">
                              <TextField
                                label={field.label}
                                value={field.value}
                                requiredIndicator={field.required}
                                multiline={field.multiline ? 2 : false}
                                onChange={() => {
                                }}
                              />
                            </BlockStack>
                          ) : null
                        }
                        {
                          field.type === 'checkbox' ? (
                            <BlockStack gap="200">
                              <InlineStack gap="100" align="start">
                                <Text variant="bodyMd">{field.label}</Text>
                                {
                                  field?.required ? (
                                    <Text variant="bodyMd" color="critical">*</Text>
                                  ) : null
                                }
                              </InlineStack>
                              <InlineStack gap="500" align="start">
                                {
                                  field.options.map((option, index) => {
                                    return (
                                      <Checkbox
                                        key={index}
                                        label={option}
                                        checked={field?.checkedOptions?.includes(option)}
                                        onChange={() => {
                                        }}
                                      />
                                    )
                                  })
                                }
                              </InlineStack>
                            </BlockStack>
                          ) : null
                        }
                        {
                          field.type === 'select' ? (
                            <Select
                              label={field.label}
                              requiredIndicator={field.required}
                              options={field.options}
                              value={field.value}
                              onChange={() => {
                              }}
                            />
                          ) : null
                        }
                      </BlockStack>
                    )
                  })
                }
              </BlockStack>
            </Card>
          ) : (
            null
          )
        }
        {
          deal?.content?.baseType ? (
            <Card>
              <BlockStack gap="500">
                <InlineStack blockAlign="center" align="space-between">
                  <InlineStack gap="300" align="start">
                    <InlineStack>
                      <Icon source={ContractIcon} />
                    </InlineStack>
                    <BlockStack gap="100">
                      <Text variant="headingMd">Content Terms & Rights</Text>
                    </BlockStack>
                  </InlineStack>
                  {
                    canEdit ? editingField === 'contentRights' ? (
                      <ButtonGroup>
                        <Button size="slim" onClick={saveDeal} loading={saveLoading}>Save</Button>
                        <Button size="slim" onClick={() => handleEditField(null)}>Cancel</Button>
                      </ButtonGroup>
                    ) : (
                      <Button size="slim" onClick={() => {
                        handleEditField('contentRights', deal?.contentRights?.terms)
                      }}>Edit</Button>
                    ) : null
                  }
                </InlineStack>
                <Divider />
                <BlockStack gap="500">
                  <BlockStack gap="100">
                    {
                      editingField === 'contentRights' ? (
                        <InstructionsRichTextEditor value={localNewValues?.contentRights} setValue={v => {
                          setLocalNewValues({ ...localNewValues, contentRights: v })
                        }} />
                      ) : <div dangerouslySetInnerHTML={{ __html: deal?.contentRights?.terms }} />
                    }
                  </BlockStack>
                  <InlineStack align="end" gap="500">
                    <BlockStack gap="300">
                      {
                        deal?.contentRights?.digitalSignature ? (
                          <BlockStack gap="100">
                            <Text>Signature</Text>
                            <input type="text" style={{ fontFamily: 'cursive', border: '1px solid grey', borderRadius: '5px', padding: '5px', fontSize: '16px' }} />
                          </BlockStack>
                        ) : null
                      }
                      <Checkbox disabled label="I agree to these terms and conditions" />
                    </BlockStack>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </Card>
          ) : null
        }
        <InlineStack align="end">
          <Button disabled>Accept</Button>
        </InlineStack>
        <Divider />
        <BlockStack gap="300" inlineAlign="center">
          <Text>Questions? Contact Us</Text>
          <Text>{store?.contactEmail || store?.email}</Text>
        </BlockStack>
      </BlockStack>
    </Box>
  )
}
